import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from 'react-router-dom';
import AppBar from '@material-ui/core/AppBar';
import IconButton from '@material-ui/core/IconButton';
import Slide from '@material-ui/core/Slide';
import { Toolbar, Typography, DialogTitle, TextField } from '@material-ui/core';
import Tooltip from '@material-ui/core/Tooltip';
import SaveIcon from '@material-ui/icons/Save';
import Button from '../controls/Button';
import { Dialog, DialogContent, DialogActions } from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import ListIcon from '@material-ui/icons/List';
import CloseIcon from '@material-ui/icons/Close';
import DoneIcon from '@material-ui/icons/Done';
import { withSnackbar } from 'notistack';

const styles = (theme) => ({
    grow: {
        flexGrow: 1,
    },
    actionBar: {
        zIndex: theme.zIndex.appBar,
        top: theme.mixins.toolbar.minHeight,
        '@media (min-width:0px) and (orientation: landscape)': {
            top: theme.mixins.toolbar['@media (min-width:0px) and (orientation: landscape)'].minHeight,
        },
        '@media (min-width:600px)': {
            top: theme.mixins.toolbar['@media (min-width:600px)'].minHeight,
        },
    },
    content: {
        paddingLeft: theme.spacing(3),
        paddingRight: theme.spacing(3),
    },
    actionButton: {
        paddingLeft: theme.spacing(1.5),
    },
    editIcon: {
        color: 'white',
    },
    actionButtonContent: {
        color: '#ffffff',
        marginLeft: theme.spacing(0.75),
    },
});

class ActionBar extends React.Component {
    state = {
        nameDialog: false,
        tempName: '',
    };

    componentDidMount() {
        this.setState({
            nameDialog: this.props.newName,
            tempName: this.props.name,
        });
    }

    componentDidUpdate(prevProps) {
        if (prevProps.name !== this.props.name && this.props.name !== this.state.tempName) {
            this.setState({
                tempName: this.props.name,
            });
        }
    }

    handleNameChange = (event) => {
        this.setState({
            tempName: event.target.value,
        });
    };

    handleNameDialogClose = () => {
        this.setState({
            nameDialog: false,
        });
    };

    handleNameDialogOpen = () => {
        this.setState({
            nameDialog: true,
        });
    };

    handleSave = () => {
        this.props.onSave(this.props.parent);
    };

    handleDelete = () => {
        this.props.onDelete();
    };

    handleToDashboard = () => {
        this.props.history.push('/');
    };

    handleSaveChanges = () => {
        if (!this.props.jsonEditorError) {
            this.props.onSave(this.props.parent, (variant) => {
                this.handleOpenSnackbar(variant);
            });
        } else {
            this.handleOpenSnackbar('error');
        }
    };

    handleCancelName = () => {
        this.setState({
            tempName: this.props.name,
        });
        this.handleNameDialogClose();
    };

    handleSaveName = (event) => {
        this.props.handleEditName(this.state.tempName);
        this.handleNameDialogClose();
        event.preventDefault();
    };

    handleOpenSnackbar = (variant) => {
        const message =
            variant === 'success'
                ? 'Saved successfully!'
                : `Your ${this.props.parent === 'formFinder' ? 'form finder' : 'form'} could not be saved`;
        this.props.enqueueSnackbar(message, {
            variant: variant,
            action: (key) => (
                <IconButton
                    key={key}
                    aria-label={key}
                    color="inherit"
                    size="small"
                    onClick={() => this.props.closeSnackbar(key)}
                >
                    <CloseIcon />
                </IconButton>
            ),
        });
    };

    render() {
        return (
            <React.Fragment>
                <Slide in={true} mountOnEnter unmountOnExit>
                    <AppBar position="fixed" color="primary" classes={{ root: this.props.classes.actionBar }}>
                        <Toolbar disableGutters={true} className={this.props.classes.content}>
                            <div>
                                <Typography edge="start" variant="h6">
                                    {this.state.tempName}
                                </Typography>
                            </div>
                            <div className={this.props.classes.actionButton}>
                                <Tooltip title="Edit" enterDelay={200} disableFocusListener={true}>
                                    <IconButton size="small" aria-label="Edit" onClick={this.handleNameDialogOpen}>
                                        <EditIcon className={this.props.classes.editIcon} />
                                    </IconButton>
                                </Tooltip>
                            </div>
                            <Dialog open={this.state.nameDialog} onClose={this.handleSaveName} fullWidth>
                                <form onSubmit={this.handleSaveName}>
                                    <DialogTitle>Name</DialogTitle>
                                    <DialogContent>
                                        <TextField
                                            label={'Name'}
                                            value={this.state.tempName}
                                            onChange={this.handleNameChange}
                                            fullWidth
                                        />
                                    </DialogContent>
                                    <DialogActions>
                                        <Button onClick={this.handleCancelName}>Cancel</Button>
                                        <Button type="submit">Save</Button>
                                    </DialogActions>
                                </form>
                            </Dialog>
                            <div className={this.props.classes.grow} />
                            {this.props.isEditingMultipleField ? (
                                <>
                                    <div className={this.props.classes.actionButton}>
                                        <Button
                                            variant="text"
                                            size="small"
                                            onClick={this.props.handleSaveMultipleField}
                                        >
                                            <DoneIcon className={this.props.classes.actionButtonContent} />
                                            <Typography
                                                variant="button"
                                                className={this.props.classes.actionButtonContent}
                                            >
                                                Apply changes & return
                                            </Typography>
                                        </Button>
                                    </div>
                                    <div className={this.props.classes.actionButton}>
                                        <Button
                                            variant="text"
                                            size="small"
                                            onClick={this.props.handleLeaveMultipleField}
                                        >
                                            <CloseIcon className={this.props.classes.actionButtonContent} />
                                            <Typography
                                                variant="button"
                                                className={this.props.classes.actionButtonContent}
                                            >
                                                Cancel & return
                                            </Typography>
                                        </Button>
                                    </div>
                                </>
                            ) : (
                                <>
                                    <div className={this.props.classes.actionButton}>
                                        <Button variant="text" size="small" onClick={this.handleToDashboard}>
                                            <ListIcon className={this.props.classes.actionButtonContent} />
                                            <Typography
                                                variant="button"
                                                className={this.props.classes.actionButtonContent}
                                            >
                                                All Forms
                                            </Typography>
                                        </Button>
                                    </div>
                                    <div className={this.props.classes.actionButton}>
                                        <Button variant="text" size="small" onClick={this.handleSaveChanges}>
                                            <SaveIcon className={this.props.classes.actionButtonContent} />
                                            <Typography
                                                variant="button"
                                                className={this.props.classes.actionButtonContent}
                                            >
                                                Save
                                            </Typography>
                                        </Button>
                                    </div>
                                </>
                            )}
                        </Toolbar>
                    </AppBar>
                </Slide>
            </React.Fragment>
        );
    }
}

export default withRouter(withStyles(styles)(withSnackbar(ActionBar)));
